import { useQuery } from '@tanstack/react-query';

import { getRewards } from '~/services/AgentHub/AgentService';

import { GetRewardsParams } from '~/types/services/agentHub';

export const rewardQueryKeys = {
  all: ['rewards'] as const,
  lists: () => [...rewardQueryKeys.all, 'list'] as const,
  list: (params: GetRewardsParams) => [...rewardQueryKeys.lists(), params] as const,
  details: () => [...rewardQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...rewardQueryKeys.details(), id] as const,
};

export function useListRewards(params: GetRewardsParams) {
  return useQuery({
    placeholderData: (prev) => {
      return {
        rows: prev?.rows ?? [],
        total: prev?.total ?? 0,
      };
    },
    queryKey: rewardQueryKeys.list(params),
    queryFn: async () => {
      return await getRewards(params);
    },
  });
}
